import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from '../views/Login.vue'
import LoginProgress from '../views/LoginProgress.vue'
import ShopFailed from '../views/registration/ShopFailed.vue'
import MailForm from '../views/registration/MailForm.vue'
import MailCodeForm from '../views/registration/MailCodeForm.vue'
import RegistrationForm from '../views/registration/RegistrationForm.vue'
import RegistrationConfirm from '../views/registration/RegistrationConfirm.vue'
import RegistrationSuccess from '../views/registration/RegistrationSuccess.vue'
import Mypage from '../views/member/MemberMypage.vue'
import WorkHistory from '../views/member/WorkHistory.vue'
import PointHistory from '../views/member/PointHistory.vue'

import Home from '../views/member/MemberHome.vue'
import PaymentEdit from '../views/member/PaymentEdit.vue'
import UpdateMonthly from '../views/member/UpdateMonthly.vue'
import ExtentionMonthly from '../views/member/ExtentionMonthly.vue'
import AddCard from '../views/member/AddCard.vue'
import BuyPoint from '../views/member/BuyPoint.vue' 
import MemberEdit from '../views/member/MemberEdit.vue';

import DebugAuth from '../views/DebugAuth.vue'
import IframeTest from '../views/IframeTest.vue'

const routes: Array<RouteRecordRaw> = [
  {path: '/login', name: 'login', component: Login},
  {path: '/login-progress', name: 'loginprogress', component: LoginProgress},
  {path: '/shop-failed', name: 'shopfailed', component: ShopFailed},
  {path: '/', name: 'home', component: Home},
  {path: '/mypage', name: 'mypage', component: Mypage},
  {path: '/edit', name: 'edit', component: MemberEdit},
  {path: '/work', name: 'work', component: WorkHistory},
  {path: '/point', name: 'point', component: PointHistory},
  {path: '/payment', name: 'paymentEdit', component: PaymentEdit},
  {path: '/monthly', name: 'monthly', component: UpdateMonthly},
  {path: '/extention', name: 'extention', component: ExtentionMonthly},
  {path: '/card', name: 'addCard', component: AddCard},
  {path: '/buy', name: 'buyPoint', component: BuyPoint},

  {path: '/registration/mail', name: 'mail', component: MailForm},
  {path: '/registration/mailcode', name: 'mailcode', component: MailCodeForm},
  {path: '/registration/form', name: 'registration', component: RegistrationForm},
  {path: '/registration/confirm', name: 'registrationConfirm', component: RegistrationConfirm},
  {path: '/registration/success', name: 'registrationSuccess', component: RegistrationSuccess},

  {path: '/debug', name: 'debug', component: DebugAuth},
  {path: '/iftest', name: 'iftest', component: IframeTest},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
